(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/form.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/form.trinidad.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (components_form)
  });
  ; 
  const external_React_namespaceObject = window["React"];
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_svs_ui_ReactForm_namespaceObject = window["svs"]["ui"]["ReactForm"];
  ; 
  const _excluded = ["className", "children", "isVertical", "onSubmit", "onValidate", "setError"];
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }
  function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
    return t;
  }

  const Form = _ref => {
    let className = _ref.className,
      children = _ref.children,
      isVertical = _ref.isVertical,
      onSubmit = _ref.onSubmit,
      onValidate = _ref.onValidate,
      setError = _ref.setError,
      props = _objectWithoutProperties(_ref, _excluded);
    const classes = ['form'];
    const validationRefs = (0, external_React_namespaceObject.useRef)({});
    const _ref2 = (0, external_React_namespaceObject.useState)({}),
      _ref3 = _slicedToArray(_ref2, 2),
      form = _ref3[0],
      setForm = _ref3[1];
    const setErrorString = setError && JSON.stringify(setError);
    if (className) {
      classes.push(className);
    }
    if (isVertical) {
      classes.push('form-vertical');
    }
    (0, external_React_namespaceObject.useEffect)(() => {
      const errors = {};
      if (setErrorString) {
        const setErrorObject = JSON.parse(setErrorString);
        for (const errorName in setErrorObject) {
          if (Object.prototype.hasOwnProperty.call(setErrorObject, errorName)) {
            errors[errorName] = {
              errorMessage: setErrorObject[errorName],
              isValid: false
            };
          }
        }
        setForm(_objectSpread(_objectSpread({}, form), errors));
      }
    }, [setError]);
    const handleBlur = (e, onBlur) => {
      if (typeof svs === 'undefined' || svs.core.data.capabilities.formFactor === 'desktop') {
        const name = e.target.name;
        const value = e.target.value;
        const validationResult = validationRefs.current[name] && validationRefs.current[name].validate('onBlur', value);
        setForm(_objectSpread(_objectSpread({}, form), {}, {
          [name]: {
            errorMessage: validationResult.errorMessage,
            isValid: validationResult.isValid
          }
        }));
        if (onValidate) {
          onValidate(name, validationResult.isValid, validationResult.errorMessage);
        }
      }
      if (onBlur) {
        onBlur(e);
      }
    };
    const handleChange = (e, onChange) => {
      const name = e.target.name;
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        [name]: {
          errorMessage: '',
          isValid: true
        }
      }));
      if (onChange) {
        onChange(e);
      }
    };
    const handleFocus = (e, onFocus) => {
      if (onFocus) {
        onFocus(e);
      }
    };
    const onSubmitHandler = e => {
      const newFormData = {};
      for (const input in validationRefs.current) {
        if (Object.prototype.hasOwnProperty.call(validationRefs.current, input)) {
          const inputRef = validationRefs.current[input];
          if (inputRef && inputRef.validate) {
            const validateResult = inputRef.validate('onSubmit', inputRef.element.value);
            newFormData[validateResult.name] = {
              errorMessage: validateResult.errorMessage,
              isValid: validateResult.isValid,
              value: inputRef.element.value
            };
          }
        }
      }
      setForm(_objectSpread(_objectSpread({}, form), newFormData));
      if (onSubmit) {
        onSubmit(e, newFormData, !Object.values(newFormData).filter(f => !f.isValid)[0]);
      }
    };
    const register = (name, validate) => element => {
      validationRefs.current[name] = null;
      if (element) {
        validationRefs.current[name] = {
          element,
          validate
        };
      }
    };
    return React.createElement("form", _extends({
      className: classes.join(' '),
      onSubmit: onSubmitHandler
    }, props), React.createElement(external_svs_ui_ReactForm_namespaceObject.FormContext.Provider, {
      value: {
        form,
        handleBlur,
        handleChange,
        handleFocus,
        register
      }
    }, children));
  };
  Form.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "Form",
    "props": {
      "children": {
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "className": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isVertical": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "onSubmit": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "onValidate": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "setError": {
        "description": "",
        "type": {
          "name": "shape",
          "value": {
            "errorMessage": {
              "name": "string",
              "required": false
            },
            "name": {
              "name": "string",
              "required": false
            }
          }
        },
        "required": false
      }
    }
  };
  const components_form = Form;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).Form = __webpack_exports__["default"];
})();

 })(window);